module.exports = __webpack_public_path__ + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-8.96d11c2c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/StrongholdExternal/components/Statistics/images/elo-icon-8.png
// module id = 3450
// module chunks = 11